export const environment = {
  production: false,
  /*
  * apiDomain - All API endpoints will/*should* be in the following format
  * ${resource}.${apiDomain}/v{versionNumber}/{path}
  */
  apiDomain: 'stage1.sandbox.gr-dev.org',
  cognito: {
    userPoolId: 'eu-west-2_kmGo1UZZc',
    clientId: '6t40s756l3gichbv1628nhj7us',
    region: 'eu-west-2',
    oauthDomain: 'auth.stage1.sandbox.gr-dev.org',
  },
};
